const url = import.meta.env.VITE_APP_API_URL ?? '';

/** Map of valid API endpoints */
const ENDPOINTS = {
  dealers: `${url}/dealers`,
  /** VMS1-6248 — dealer home location (GET /dealer/detail/{dealerId}), not part of the dealers response. */
  dealerInfo: `${url}/dealer/detail`,
  keepalive: `${url}/auth/keepalive`,
  login: `${url}/auth/login`,
  logout: `${url}/auth/logout`,
  resetInit: `${url}/auth/resetInit`,
  resetComplete: `${url}/auth/resetComplete`,
  change: `${url}/auth/change`,
  inventory: `${url}/inventory`,
  vdpPriceData: `${url}/vdpPriceData`,
  similarVins: `${url}/similarVins`,
  marketDemandData: `${url}/marketDemandData`,
  inventoryTableConfig: `${url}/inventoryTableConfig`,
  addBudget: `${url}/addBudget`,
  vvo: `${url}/vvo`,
  vvoSpend: `${url}/vvo/spend`,
  vvoConfigureInvestment: `${url}/vvo/configureInvestment`,
  inquiry: `${url}/inquiry`,
  inquiryConversationList: `${url}/inquiry/conversation/list`,
  inquiryConversationMessage: `${url}/inquiry/conversation/responses`,
  inquiryPollStart: `${url}/inquiry/poll/start`,
  inquiryPollStatus: `${url}/inquiry/poll/status`,
  inquirySuggestions: `${url}/inquiry/suggestions`,
  inquiryVoiceToText: `${url}/inquiry/voiceToText`,
  inquiryConversationShare: `${url}/inquiry/conversation/share`,
  beforeAndAfter_trendMetrics: `${url}/beforeAndAfter/trendMetrics`,
  beforeAndAfter_trendFilters: `${url}/beforeAndAfter/trendFilters`,
  campaignData: `${url}/campaign/list`,
  campaign_performance: `${url}/campaign/performance`,
  campaign_defaults: `${url}/campaign/defaults`,
  campaign_promos: `${url}/campaign/promos`,
  campaign_authorized_list: `${url}/campaign/authorizedList`,
  campaign_validation: `${url}/campaign/validation`,
  campaign_creation: `${url}/campaign/creation`,
  campaign_conversion_report: `${url}/campaign/reports/conversions`,
  campaignFilters: `${url}/campaign/filters`,
  campaignEditDetails: `${url}/campaign/edit/details`,
  campaignEdit: `${url}/campaign/edit`,
  campaignEditValidation: `${url}/campaign/edit/validation`,
  campaignCancellation: `${url}/campaign/cancellation`,
  market_opportunity: `${url}/market/performance`,
  market_segments: `${url}/market/insights/segments`,
  leads: `${url}/leads`,
  local_market_settings: `${url}/settings/localMarket`,
  geoConfigSettings: `${url}/settings/geoConfig`,
  inventoryHealthThresholdsSettings: `${url}/settings/inventoryHealthThresholds`,
  vinTvConfigSettings: `${url}/settings/vinTv`,
  showroom: `${url}/settings/showroom`,
  vmxAccessAccounts: `${url}/settings/extension/accounts/byDealer`,
  // vmxAccessAccountsById: `${url}/settings/extension/accounts/byAccount`,
  vmxPermissionRequests: `${url}/settings/extension/permissions`,
  vmxSavePermissionsRequest: `${url}/settings/extension/permission`,
  vmxUpdateAccountRequest: `${url}/settings/extension/account`,
  vmxCreateInvite: `${url}/settings/extension/createInvite`,
  permissionRequests: `${url}/extension/permissionRequests`,
  photoAi: `${url}/settings/photoAI`,
  tooltipConfig: `${url}/tooltipConfig`,
  tooltips: `${url}/tooltips`,
  riskReport: `${url}/reports/risk`,
  riskOverview: `${url}/reports/risk/overview`,
  roiReport: `${url}/reports/roi`,
  roiSimulate: `${url}/reports/roi/simulate`,
  saveSegmentFavorites: `${url}/market/segments/favorites`,
  saveDealerFavorites: `${url}/dealers/favorites`,
  marketInsights: `${url}/market/insights`,
  marketInsightsDemand: `${url}/market/insights/demand`,
  marketInsightsMetric: `${url}/market/insights/metric`,
  events: `${url}/eventsV2`,
  inventoryBreakdown: `${url}/inventory/breakdown`,
  carryoverBreakdown: `${url}/inventory/breakdown/chart`,
  acquisition: `${url}/acquisition`,
  vinPathPriceData: `${url}/vinPathPriceData`,
  lexSubmitFeedback: `${url}/storeLexResponseFeedback2`,
  getCacheStatus: `${url}/cache/status`,
  initiateCacheRebuild: `${url}/cache/rebuild`,
  campaignOverview: `${url}/campaign/overview`,
  campaignOverviewOverview: `${url}/campaign/overview/overview`,
  campaignOverviewUpcoming: `${url}/campaign/overview/overview/upcoming`,
  campaignOverviewInventory: `${url}/campaign/overview/inventory`,
  campaignOverviewInventoryShoppers: `${url}/campaign/overview/inventory/shoppers`,
  campaignOverviewShoppers: `${url}/campaign/overview/shoppers`,
  campaignOverviewDelivery: `${url}/campaign/overview/delivery`,
  campaignOverviewInvestment: `${url}/campaign/overview/investment`,
  conversationList: `${url}/inquiry/conversation/list`,
  conversationMessage: `${url}/inquiry/conversation/message`,
  performanceResults: `${url}/campaign/performanceResults`,
  performanceResultsNotification: `${url}/campaign/performanceResultsNotification`,
  vsr: `${url}/reports/vsr`,
  reportsDownload: `${url}/reports/download`,
  quickboost: `${url}/campaign/quickboost`,
  quickboostedVins: `${url}/campaign/quickboostedVins`,
  campaignActivity: `${url}/landingDashboard/campainActivity`,
  campaignsTable: `${url}/landingDashboard/campaignsTable`,
  recommendedVinBoosts: `${url}/landingDashboard/recommendedVinBoosts`,
  advertisingAssistantPageData: `${url}/newVVO`,
  vehicleSidebarData: `${url}/newVVO/vehicleSidebar`,
  wasteSidebarData: `${url}/newVVO/wasteSidebar`,
  inventoryMetrics: `${url}/inventory/metrics`,
  access: `${url}/access`,
  idp: `${url}/idp`,
  keyCompetitorsLineChart: `${url}/market/insights/keyCompetitorsLineChart`,
  progressBarSection: `${url}/market/insights/progressBarSection`,
  stockRankCard: `${url}/market/insights/stockRank`,
  salesRankCard: `${url}/market/insights/salesRank`,
  overallMarketRank: `${url}/market/insights/overallMarketRank`,
  opportunityCard: `${url}/market/insights/opportunity`,
  hexMap: `${url}/market/insights/hexMap`,
  vinListInventory: `${url}/market/insights/vinListInventory`,
  underexposedVins: `${url}/market/insights/underexposedVins`,
  shopperEngagement: `${url}/market/insights/shopperEngagement`,
  idp2FaRequest: `${url}/idp/2fa/request`,
  idp2FaAttempts: `${url}/idp/2fa/attempts`,
  idp2FaValidate: `${url}/idp/2fa/verify`,
  idpPii: `${url}/idp/pii`,
  /** VMS1-6113 — Revive (CRM lead) profile, keyed by `leadId`. Replaces `/idp/profile`. */
  idpReviveProfile: `${url}/idp/revive/profile`,
  /** VMS1-6113 — Reveal (ILM household) profile, keyed by `householdId`. */
  idpRevealProfile: `${url}/idp/reveal/profile`,
  idpShoppedVinEvents: `${url}/idp/shoppedVinEvents`,
  idpNotifications: `${url}/idp/notifications`,
  /** VMS1-6394 — identified-shopper (Reveal) session ids bucketed by day, for the Shoppers chart. */
  idpRevealTimeline: `${url}/idp/reveal/timeline`,
  idpRecentlyRecommendedVehicles: `${url}/idp/recentlyRecommendedVehicles`,
} as const;
export default ENDPOINTS;
